/**
 * The preview-runner's session id for a service, built exactly as the runner builds it
 * (container-live/preview-runner, `crates/core/src/session.rs::build_session_id`):
 *   - with a project: `<project>-<service with every "/" turned into "-">`, e.g. `pgcheck-services-app`
 *     (the user id is never part of it: every caller of the same project and service shares one session);
 *   - without a project (the old non-vfs flow): `<service>-<user>`, or the service alone.
 *
 * The one place the FE builds a session id. Before it, Canvas and previewSession.js each built their own
 * (`<project>-<service>-<user>`, slash kept), e.g. `pgcheck-services/app-<uuid>`: an id the runner never has, so
 * every status, logs-stream and restart call on it answered 404 and the Preview never saw the service start.
 *
 * @param {string|null|undefined} projectId
 * @param {string} serviceName the service dir (`services/app`)
 * @param {string|null} [userId] only used without a project
 * @returns {string}
 */
export function buildSessionId(projectId, serviceName, userId = null) {
  const service = String(serviceName ?? '').replace(/\//g, '-');
  if (projectId) { return `${projectId}-${service}`; }
  if (userId) { return `${service}-${userId}`; }
  return service;
}

export default buildSessionId;
